import React from 'react';
import './VenueForm.css';

function VenueForm({ form, onChange, onSubmit, isSubmitting, musicOptions, locationOptions }) {
  return (
    <div className="form-container">
      <input
        name="venue_name"
        placeholder="Venue Name"
        value={form.venue_name}
        onChange={onChange}
        style={{ marginBottom: '8px', display: 'block' }}
      />
      <textarea
        name="description"
        placeholder="Description"
        value={form.description}
        onChange={onChange}
        rows={4}
        style={{ marginBottom: '8px', display: 'block', width: '100%' }}
      />

      <div style={{ marginBottom: '8px' }}>
        <label>
          <input
            type="checkbox"
            name="live_music_ind"
            checked={form.live_music_ind}
            onChange={(e) => onChange({ target: { name: 'live_music_ind', value: e.target.checked } })}
          /> Live Music
        </label>
        <label style={{ marginLeft: '10px' }}>
          <input
            type="checkbox"
            name="dancefloor_ind"
            checked={form.dancefloor_ind}
            onChange={(e) => onChange({ target: { name: 'dancefloor_ind', value: e.target.checked } })}
          /> Dancefloor
        </label>
        <label style={{ marginLeft: '10px' }}>
          <input
            type="checkbox"
            name="live_ind"
            checked={form.live_ind}
            onChange={(e) => onChange({ target: { name: 'live_ind', value: e.target.checked } })}
          /> Live
        </label>
      </div>

      <div style={{ marginBottom: '8px' }}>
        <label>Music:</label>
        <select
          multiple
          name="music_ids"
          value={form.music_ids}
          onChange={(e) => {
            const selected = Array.from(e.target.selectedOptions, option => parseInt(option.value));
            onChange({ target: { name: 'music_ids', value: selected } });
          }}
          style={{ display: 'block', width: '100%' }}
        >
          {musicOptions.map(music => (
            <option key={music.music_id} value={music.music_id}>{music.music_name}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '8px' }}>
        <label>Location:</label>
        <select
          name="location_id"
          value={form.location_id}
          onChange={onChange}
          style={{ display: 'block', width: '100%' }}
        >
          <option value="">Select Location</option>
          {locationOptions.map(loc => (
            <option key={loc.location_id} value={loc.location_id}>{loc.location_name}</option>
          ))}
        </select>
      </div>

      <button onClick={onSubmit} disabled={isSubmitting}>
        {isSubmitting ? 'Saving...' : 'Save Venue'}
      </button>
    </div>
  );
}

export default VenueForm;
